import { LocationMatchType } from 'app/enum';

import { MatchType } from '../constants/match-type';

const MATCH_TYPE = 'analog_match_type';
const LOCATION_MATCH_TYPE = 'analog_location_match_type';

class LocalPreferenceManager {
    private readonly storage;

    public constructor() {
        this.storage = localStorage;
    }

    public getPreferredMatchType(): MatchType {
        const value = this.storage.getItem(MATCH_TYPE);
        if (!value) {
            return MatchType.REGEX;
        }

        if (Object.values(MatchType).includes(value as MatchType)) {
            return value as MatchType;
        }

        return MatchType.REGEX;
    }
    public getPreferredLocationMatchType(): LocationMatchType {
        const value = this.storage.getItem(LOCATION_MATCH_TYPE);
        if (!value) {
            return LocationMatchType.EQUAL;
        }

        if (Object.values(LocationMatchType).includes(value as LocationMatchType)) {
            return value as LocationMatchType;
        }

        return LocationMatchType.EQUAL;
    }

    public setPreferredMatchType(value: MatchType): void {
        this.storage.setItem(MATCH_TYPE, value);
    }
    public setPreferredLocationMatchType(value: LocationMatchType): void {
        this.storage.setItem(LOCATION_MATCH_TYPE, value);
    }
}

export const localPreferenceManager = new LocalPreferenceManager();
